import { render } from "./certificates_and_reports.html?vue&type=template&id=523eaf9d&external"
import script from "./certificates_and_reports.js?vue&type=script&lang=js&external"
export * from "./certificates_and_reports.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__